<template>
  <div class="field" :class="{'is-horizontal':isHorizontal}">
    <div v-if="isHorizontal" class="field-label" :class="{'is-normal':(isNormal && !sub)}">
      <field-label :label="label" :sub="sub"/>
    </div>
    <field-label v-else :label="label" :sub="sub"/>
    <div v-if="isHorizontal" class="field-body">
      <div v-if="hasWrap" class="field" :class="{'is-grouped':isGrouped, 'is-narrow':isNarrow}">
        <div class="control">
          <slot/>
        </div>
        <slot name="help"/>
      </div>
      <slot v-else/>
    </div>
    <slot v-else/>
  </div>
</template>

<script>
  import FieldLabel from '@/components/FieldLabel'
  export default {
    name: "FormField",
    components: {
      FieldLabel
    },
    props: {
      label: {
        type: String,
        default: null,
      },
      sub: {
        type: String,
        default: null,
      },
      isNormal: {
        type: Boolean,
        default: true,
      },
      isGrouped: {
        type: Boolean,
        default: false,
      },
      isNarrow: {
        type: Boolean,
        default: false,
      },
      isHorizontal: {
        type: Boolean,
        default: true,
      },
      hasWrap: {
        type: Boolean,
        default: true,
      }
    }
  }
</script>

<style scoped>

</style>